export default "__VITE_ASSET__365f7e11__"